'use strict'

module.exports = {

    // URLがメールリンクを使用したサインインかどうか
    'isSignInWithEmailLink': {
        'error': "無効なURLです。会員登録メールの送信からやり直してください。"
    },

    // メールリンクを使用してサインイン
    'signInWithEmailLink': {
        'success': "会員登録しました。",
        'error': "会員登録に失敗しました。",
        'error_code': {
            'auth/expired-action-code': "URLの有効期限が切れています。会員登録メールの送信からやり直してください。",
            'auth/invalid-action-code': "無効なURLです。会員登録メールの送信からやり直してください。",
            'auth/invalid-email': "無効なメールアドレスです。会員登録メールの送信からやり直してください。",
            'auth/user-disabled': "無効なユーザーです。会員登録メールの送信からやり直してください。",
        }
    },

    // パスワード更新
    'updatePassword': {
        'success' : 'パスワードを更新しました。',
        'error' : 'パスワードの更新に失敗しました。',
        'error_code': {
            'auth/weak-password': "パスワードの強度が十分ではありません。",
            'auth/requires-recent-login': "再認証が必要です。再ログインしてください。",
        }
    },

    // パスワードリセットコードを検証
    'verifyPasswordResetCode': {
        'error': "パスワードリセットに失敗しました。",
        'error_code': {
            'auth/expired-action-code': "URLの有効期限が切れています。パスワード再設定メールの送信からやり直してください。",
            'auth/invalid-action-code': "無効なURLです。パスワード再設定メールの送信からやり直してください。",
            'auth/user-disabled': "無効なユーザーです。パスワード再設定メールの送信からやり直してください。",
            'auth/user-not-found': "対象のユーザーが見つかりません。パスワード再設定メールの送信からやり直してください。",
        }
    },

    // 新しいパスワードを保存
    'confirmPasswordReset': {
        'success': "パスワードを変更しました。"
    },

    // メールアドレス、パスワードでログイン
    'signInWithEmailAndPassword': {
        'success' : "ログインしました。",
        'error': "ログインに失敗しました。",
        'error_code': {
            'auth/invalid-email': "無効なメールアドレスです。",
            'auth/user-disabled': "無効なユーザーです。",
            'auth/user-not-found': "メールアドレスまたはパスワードが正しくありません。ソーシャルアカウントでのログインもお試しください。",
            'auth/wrong-password': "メールアドレスまたはパスワードが正しくありません。ソーシャルアカウントでのログインもお試しください。",
            'auth/too-many-requests': "ログイン試行回数が上限を超えました。しばらく時間をおいてから、もう一度お試しください。",
        }
    },

    // SNSデフォルトプロバイダーでログイン
    'signInWithPopup': {
        'success' : "ログインしました。",
        'error': "ログインに失敗しました。",
        'error_code': {
            'auth/account-exists-with-different-credential': "同一メールアドレスのアカウントがすでに認証済みです。",
            'auth/auth-domain-config-required': "現在この認証方法はご利用いただけません。",
            'auth/cancelled-popup-request': "多重ログイン防止のため、リクエストをキャンセルしました。",
            'auth/operation-not-allowed': "現在この認証方法はご利用いただけません。",
            'auth/operation-not-supported-in-this-environment': "現在この認証方法はご利用いただけません。",
            'auth/popup-blocked': "ポップアップがブラウザによりブロックされました。ポップアップを許可するよう設定の変更を願います。",
            'auth/unauthorized-domain': "現在この認証方法はご利用いただけません。",
        }
    },

    // SNSデフォルトプロバイダを連携
    'linkWithPopup': {
        'success' : "連携しました。",
        'error': "連携に失敗しました。",
        'error_code': {
            'auth/auth-domain-config-required': "現在この認証方法はご利用いただけません。",
            'auth/cancelled-popup-request': "多重連携防止のため、リクエストをキャンセルしました。",
            'auth/credential-already-in-use': "このアカウントはすでに登録済みです。",
            'auth/email-already-in-use': "このメールアドレスはすでに登録済みです。",
            'auth/operation-not-allowed': "現在この認証方法はご利用いただけません。",
            'auth/popup-blocked': "ポップアップがブラウザによりブロックされました。ポップアップを許可するよう設定の変更を願います。",
            'auth/operation-not-supported-in-this-environment': "現在この認証方法はご利用いただけません。",
            'auth/provider-already-linked': "このプロバイダはすでにリンク済みです。",
            'auth/unauthorized-domain': "現在この認証方法はご利用いただけません。",
        }
    },

    // SNSデフォルトプロバイダの連携解除
    'unlink': {
        'success' : "連携解除しました。",
        'error': "連携解除に失敗しました。",
        'error_code': {
            'auth/no-such-provider': "指定のプロバイダとはリンクしていません。",
        }
    },

    // 再認証
    'password.reauthenticateWithCredential' : {
        'success' : 'パスワード認証に成功しました。',
        'error' : 'パスワード認証に失敗しました。',
        'error_code': {
            'auth/user-mismatch': '資格情報が一致しません。',
            'auth/user-not-found': 'パスワードが正しくありません。',
            'auth/invalid-credential': "資格情報が無効です。",
            'auth/invalid-email': "無効なメールアドレスです。",
            'auth/wrong-password': "パスワードが正しくありません。",
            'auth/invalid-verification-code': "資格情報の検証コードが無効です。",
            'auth/invalid-verification-id': "資格情報の検証IDが無効です。",
            'auth/too-many-requests': "パスワード認証の試行回数が上限を超えました。しばらく時間をおいてから、もう一度お試しください。",
        }
    },

    // メールアドレス登録
    'regist.updateEmail': {
        'success' : 'メールアドレスの登録を受け付けました。',
        'error' : 'メールアドレスの登録に失敗しました。',
        'error_code': {
            'auth/invalid-email': "無効なメールアドレスです。",
            'auth/email-already-in-use': "ご指定のメールアドレスは既に使用されています。",
            'auth/requires-recent-login': "再認証が必要です。再ログインしてください。",
            'auth/invalid-email': "無効なメールアドレスです。",
            'auth/invalid-email': "無効なメールアドレスです。",
            'auth/internal-error': "エラーが発生しました。時間をおいてもう一度手続きをしてください。"
        }
    },

    // メールアドレス変更
    'change.updateEmail': {
        'success' : 'メールアドレスの変更を受け付けました。',
        'error' : 'メールアドレスの変更に失敗しました。',
        'error_code': {
            'auth/invalid-email': "無効なメールアドレスです。",
            'auth/email-already-in-use': "ご指定のメールアドレスは既に使用されています。",
            'auth/requires-recent-login': "再認証が必要です。再ログインしてください。",
            'auth/internal-error': "エラーが発生しました。時間をおいてもう一度手続きをしてください。"
        }
    },

    // 確認メール送信
    'sendEmailVerification': {
        'success' : "送信された確認メール本文に記載されているURLから、登録を完了させてください。",
        'error' : "確認メールの送信に失敗しました。",   
        'error_code': {
            'mail/oringin-does-not-match': "通信エラーが発生しました。もう一度ブラウザを開き直して手続きをしてください。",
            'mail/already-userexists': "入力されたメールアドレスですでにユーザが登録されています。",
            'mail/no-user-exists': "入力されたメールアドレスは登録されていません。",
            'mail/may-be-bot-access': "エラーが発生しました。時間をおいてもう一度手続きをしてください。",
            'mail/email-not-found': "メールアドレスが正しく入力されていません。",
            'auth/internal-error': "エラーが発生しました。時間をおいてもう一度手続きをしてください。"
        }
    },

    // 確認メールのアクションコードを適用
    'verifyEmail.applyActionCode': {
        'success': "メールアドレスを確認しました。",
        'error': "メールアドレスの確認に失敗しました。",
        'error_code': {
            'auth/expired-action-code': "URLの有効期限が切れています。確認メールの送信からやり直してください。",
            'auth/invalid-action-code': "無効なURLです。確認メールの送信からやり直してください。",
            'auth/user-disabled': "無効なユーザーです。確認メールの送信からやり直してください。",
            'auth/user-not-found': "対象のユーザーが見つかりません。確認メールの送信からやり直してください。",
        }
    },

    // メールアドレス復元のアクションコードをチェック
    'recoverEmail.checkActionCode': {
        'error': "メールアドレスを復元できませんでした。",
        'error_code': {
            'auth/expired-action-code': "URLの有効期限が切れています。",
            'auth/invalid-action-code': "無効なURLです。",
            'auth/user-disabled': "無効なユーザーです。",
            'auth/user-not-found': "対象のユーザーが見つかりません。",
        }
    },

    // メールアドレス復元のアクションコードを適用
    'recoverEmail.applyActionCode': {
        'success': "メールアドレスの変更がキャンセルされ、メールアドレスが「email」に戻りました。",
    },

    // サインアップメールの送信
    'sendSignUpEmail': {
        'success': "ログイン用のメールを送信しました。メール本文中のURLをクリックしてください。",
        'error': "ログイン用メールの送信に失敗しました。",
        'error_code': {
            'mail/oringin-does-not-match': "通信エラーが発生しました。もう一度ブラウザを開き直して手続きをしてください。",
            'mail/already-userexists': "入力されたメールアドレスですでにユーザが登録されています。",
            'mail/no-user-exists': "入力されたメールアドレスは登録されていません。",
            'mail/may-be-bot-access': "エラーが発生しました。時間をおいてもう一度手続きをしてください。",
            'mail/email-not-found': "メールアドレスが正しく入力されていません。",
            'auth/internal-error': "エラーが発生しました。時間をおいてもう一度手続きをしてください。"
        }
    },

    // パスワード再設定メールの送信
    'sendPasswordResetEmail': {
        'success': "ログイン用のメールを送信しましたのでメール本文中のURLをクリックしてください。",
        'error': "パスワード再設定メールの送信に失敗しました。",
        'error_code': {
            'mail/oringin-does-not-match': "通信エラーが発生しました。もう一度ブラウザを開き直して手続きをしてください。",
            'mail/already-userexists': "入力されたメールアドレスですでにユーザが登録されています。",
            'mail/no-user-exists': "入力されたメールアドレスは登録されていません。ソーシャルアカウントでのログインもお試しください。",
            'mail/may-be-bot-access': "エラーが発生しました。時間をおいてもう一度手続きをしてください。",
            'mail/email-not-found': "メールアドレスが正しく入力されていません。",
            'auth/internal-error': "エラーが発生しました。時間をおいてもう一度手続きをしてください。"
        }
    },
}
